import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { unitSystem as unitSystemState } from '@/components/Analysis/state';
import GenericBarChartHorizontal from '@/components/shared/GenericBarChartHorizontal/GenericBarChartHorizontal';
import { localiseMeasurement } from '@/utils/unitSystem';
import { UnitsEnum } from '../../../../__generated__/graphql';

interface DataItem {
  [key: string]: string | number;
}

interface CoatingBreakdownGraphProps {
  title: string;
  data: DataItem[];
  legendData: {
    [key: string]: string;
  };
  showUnit?: boolean;
}

export const TemporalAnalysisGraphs = ({
  title,
  data,
  legendData,
  showUnit,
}: CoatingBreakdownGraphProps) => {
  const unitSystem = useAtomValue(unitSystemState);

  const transformedData = useMemo(() => {
    return data.map((item) => {
      const transformedItem: { name: string; [key: string]: number | string } = {
        name: String(item.name),
        ...item,
      };
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number' && showUnit !== false) {
          transformedItem[key] = Number(
            localiseMeasurement({
              unitSystem,
              sourceUnit: UnitsEnum.SquareMeter,
              value: Number(item[key]),
            })
          );
        }
      });
      return transformedItem;
    });
  }, [data, showUnit, unitSystem]);

  return (
    <>
      <GenericBarChartHorizontal
        title={title}
        data={transformedData}
        legendData={legendData}
        showUnit={showUnit}
      />
    </>
  );
};
